<template>
  <div class="winner-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入手机号查找..."></Input>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.type" clearable placeholder="请选择类型...">
              <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.status" clearable placeholder="请选择状态...">
              <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd"
              @on-change="changeDate"
              style="width: 260px"
              placeholder="下单时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable(1)">查找</Button>
          </FormItem>
          <FormItem>
            <Button @click="showModel()" type="success" class="f-l">添加</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="50%"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="goods" :label-width="80" ref="goodsValidate" :rules="goodsValidate">
        <FormItem label="分类">
          <Select
            v-model="goods.type"
            clearable
            filterable
            placeholder="选择分类"
            @on-change="goodtypestatus"
          >
            <Option :value="0">商品</Option>
            <Option :value="1">材料</Option>
          </Select>
        </FormItem>
        <FormItem label="选择商品" label-position="top">
          <Select v-model="goods.pool_good_data_id" clearable filterable placeholder="选择商品">
            <Option v-for="item in goodtablelist" :value="item.id" :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="会员名称" label-position="top">
          <Input v-model="goods.phone" placeholder="请输入手机号"></Input>
        </FormItem>
        <FormItem label="开奖时间">
          <DatePicker
            v-model="goods.open_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="开奖时间"
            style="width: 200px"
            @on-change="changeDateOne"
          ></DatePicker>
        </FormItem>
        <FormItem label="是否发布">
          <RadioGroup v-model="goods.is_publish">
            <Radio label="1" border>是</Radio>
            <Radio label="0" border>否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        <Button type="primary" @click="creategoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: "winner-list",
  data() {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      goodtablelist: [],
      typeList: [
        { id: 0, name: "订单" },
        { id: 1, name: "人工" }
      ],
      statusList: [
        { id: 0, name: "未发布" },
        { id: 1, name: "已发布" }
      ],
      goods: {
        type: "0",
        phone: "",
        is_publish: "1"
      },
      isable: true,
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: "",
        datetime: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 80
        },
        {
          title: "会员名",
          key: "username",
          minWidth: 200
        },
        {
          title: "奖品id",
          key: "good_id",
          minWidth: 80
        },
        {
          title: "奖品名称",
          key: "title",
          minWidth: 80
        },
        {
          title: "奖品属性",
          key: "attr",
          minWidth: 80
        },
        {
          title: "类型",
          key: "user_type",
          minWidth: 80
        },
        {
          title: "订单状态",
          key: "order_status",
          minWidth: 80
        },
        {
          title: "发布状态",
          key: "is_publish",
          minWidth: 80
        },
        {
          title: "开奖时间",
          key: "open_time",
          width: 180
        },
        {
          title: "操作",
          key: "action",
          width: 80,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type:
                      params.row.is_publish == "未发布" ? "success" : "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      params.row.is_publish == "未发布"
                        ? this.editStatus(params.row.id, 1)
                        : this.editStatus(params.row.id, 0);
                    }
                  }
                },
                params.row.is_publish == "未发布" ? "发布" : "撤销"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      goodsValidate: {
        phone: [
          { required: true, message: "会员名称必须填写", trigger: "blur" }
        ]
        // thumb: [{ required: true, validator: validateThumb, trigger: "change" }]
      },
      id: 0
    };
  },
  created: function() {
    this.getTableList();
  },
  components: {
    UploadThumb
  },

  methods: {
    getTableList: function() {
      this.$api.winner
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    //获取商品
    getGoodList: function(index) {
      this.$api.winner
        .productgoodlist({
          type: index
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.goodtablelist = res.result;
          }
        });
      return;
    },
    changeDate(val) {
      this.formItem.datetime = val;
    },
    changeDateOne(val) {
      this.goods.open_time = val;
    },
    // 切换产品池展示形式
    goodtypestatus: function(val) {
      this.getGoodList(val);
    },
    // 展开添加
    showModel() {
      this.title = "添加记录";
      this.isBlockGoods = false;
      this.goods = {
        phone: "",
        is_publish: "1",
        type: 0
      };
      this.getGoodList(0);
      this.isable = true;
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },

    // 添加
    creategoods(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //新建商品
          this.$api.winner.create(this.goods).then(res => {
            if (res.code == 200) {
              this.getTableList();
              this.showModalStatus = false;
            }
            this.goods.id = null;
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 上下架
    editStatus: function(id, index) {
      this.$api.winner.status({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function(name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      var ps = {
        key: this.formItem.key,
        type: this.formItem.type,
        status: this.formItem.status,
        page: this.pages.page,
        size: this.pages.size,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.winner.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>



